import { Center } from '@chakra-ui/react';
import { FinishedIcon } from '@halo/ui-chat-react';

export interface MessagingStatusReadProcessProps {
  process: number;
  processScale?: number;
  color?: string;
  hideMember?: boolean;
}

export const MessagingStatusReadProcess = memo(function MessagingStatusReadProcess({
  process = 0,
  processScale = 1.2,
  color,
  hideMember,
}: MessagingStatusReadProcessProps) {
  const endX = useMemo(() => {
    return 6 + 3 * Math.sin(process * 2 * Math.PI);
  }, [process]);

  const endY = useMemo(() => {
    return 6 - 3 * Math.cos(process * 2 * Math.PI);
  }, [process]);

  const bigAngle = useMemo(() => {
    return +(process > 0.5);
  }, [process]);

  return process >= 1 ? (
    <Center fontSize="sm" boxSize={`${processScale * 1.1}em`}>
      <FinishedIcon style={{ color: 'var(--colors-bg-success)' }} />
    </Center>
  ) : (
    <Center cursor={hideMember ? 'default' : 'pointer'} boxSize={`${processScale * 1.1}em`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        transform={`scale(${processScale})`}
        style={{ color }}
      >
        <circle
          cx="6"
          cy="6"
          r="4.58333"
          stroke={process === 0 ? 'currentColor' : 'var(--colors-bg-success)'}
          strokeWidth="0.833333"
        />
        <path
          d={`M6,6 L6,3 A3,3 0 ${bigAngle} 1 ${endX},${endY}`}
          fill="var(--colors-bg-success)"
        />
      </svg>
    </Center>
  );
});
